const deDE = {
  'common.appTitle': 'Performance Coach',
  'common.formHasErrors': 'Bitte überprüfen Sie das Formular auf fehlende Pflichtfelder',
  'common.from': 'Von',
  'common.to': 'Bis',
  'common.today': 'Heute',
  'common.more': 'mehr',
  'common.editEntity': 'Bearbeiten',
  'common.abort': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.language': 'Sprache auswählen',
  'common.defaultMenuTitle': 'Termine',
  'common.signOut': 'Abmelden',
  'common.defaultStoreSettings': 'NDL Einstellungen',
  'common.save': 'Speichern',
  'common.confirm': 'Bestätigen',
  'common.error': 'Fehler',
  'common.defaultError': 'Etwas ist schief gelaufen',
  'common.defaultErrorDescription': 'Cache löschen und neu laden',
  'common.createAppointmentError': 'Beim Erstellen des Termins ist ein Fehler aufgetreten',
  'common.createAppointmentErrorDescription': 'Der Termin wurde nicht erstellt. Bitte überprüfen Sie die Internetverbindung',
  'common.deleteAppointmentError': 'Ein Fehler ist aufgetreten, als versucht wurde, den Termin zu löschen',
  'common.deleteAppointmentErrorDescription': 'Der Termin wurde nicht gelöscht. Bitte überprüfen Sie Ihre Internetverbindung',
  'common.appVersion': 'Version',
  'common.minutesShort': '{minutes} min',
  'common.hour': 'Hour',
  'common.minutes': 'Minutes',
  'common.gender.none': '-',
  'common.gender.male': 'Herr',
  'common.gender.female': 'Frau',
  'common.search': 'Suche',
  'common.epepSyncInProcess': 'Import der {source}-Daten gestartet',
  'common.epepSyncDelay': 'Warten auf {source}-Daten: {delay}s',
  'common.pageNotFound': 'Seite nicht gefunden',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.clearFilters': 'Filter löschen',
  'menu.operations': 'Operations',
  'menu.performance': 'Performance',
  'menu.appointments': 'Termine',
  'menu.settings': 'Einstellungen',
  'performanceIndicatorsColumnName.region': 'Region',
  'performanceIndicatorsColumnName.storeid': 'Filial-ID',
  'performanceIndicatorsColumnName.ltb_status': 'LTB Status',
  'performanceIndicatorsColumnName.store_name': 'Filialname',
  'performanceIndicatorsColumnName.last_week': 'Letzte Woche',
  'performanceIndicatorsColumnName.last_week_prev_year': 'Letzte Woche im Vorjahr',
  'performanceIndicatorsColumnName.problems_count': 'Anzahl an identifizierten Problemen',
  'performanceIndicatorsColumnName.capacity_flag': 'Sehtest-Mitarbeiter Kapazität ist deutlich gesunken (mehr als 15% vgl. zum 1. Halbjahr 2024)',
  'performanceIndicatorsColumnName.capacity_flag_1': 'Sehtest-Mitarbeiter Kapazität fehlt',
  'performanceIndicatorsColumnName.potential_flag': 'WIP: (Refraktions-)Potential wird nicht ausgeschöpft',
  'performanceIndicatorsColumnName.potential_flag_1': 'Potential nicht ausgeschöpft',
  'performanceIndicatorsColumnName.wait_time_flag': 'Wartezeit über 10 min',
  'performanceIndicatorsColumnName.wait_time_flag_1': 'Hohe Wartezeit',
  'performanceIndicatorsColumnName.productivity_flag': 'WIP: Produktivität ist zu niedrig',
  'performanceIndicatorsColumnName.productivity_flag_1': 'Produktivität unterdurchschnittlich',
  'performanceIndicatorsColumnName.service_time_flag': 'Sehtest/Beratung Servicezeit über 40 min',
  'performanceIndicatorsColumnName.service_time_flag_1': 'S/B Servicezeit >40 min',
  'performanceIndicatorsColumnName.walkin_ratio_flag': 'Terminquote ist unterdurchschnittlich (<30%) oder überdurchschnittlich (>70%)',
  'performanceIndicatorsColumnName.walkin_ratio_flag_0': 'Niedrige Terminquote',
  'performanceIndicatorsColumnName.walkin_ratio_flag_1': 'Hohe Terminquote',
  'performanceIndicatorsColumnName.service_split_flag': 'Viele Mitarbeiter mit Beratung- aber ohne Sehtest-Fähigkeit (>25% der Beratungs-Mitarbeiter)',
  'performanceIndicatorsColumnName.service_split_flag_1': 'Servicesplit könnte sinnvoll sein',
  'performanceIndicatorsColumnName.status_50_pct_rule': '50 % Rule',
  'performanceIndicatorsColumnName.conversion_rate_flag': 'Abschöpfung - Aufträge kleiner 15% der Kundenfrequenz',
  'performanceIndicatorsColumnName.conversion_rate_flag_0': 'Keine Kundenfrequenz-Daten vorhanden',
  'performanceIndicatorsColumnName.conversion_rate_flag_1': 'Schlechte Abschöpfung der Kundenfrequenz',
  'performanceIndicatorsColumnName.cust_interest_freq_flag': 'Kundeninteresse laut Frequenz gesunken um mindestens 15%',
  'performanceIndicatorsColumnName.cust_interest_freq_flag_0': 'Frequenzdaten fehlen',
  'performanceIndicatorsColumnName.cust_interest_freq_flag_1': 'Kundeninteresse laut Frequenz gesunken um >15%',
  'performanceIndicatorsColumnName.relative_performance_flag': 'Vergleich Aufträge zum Vorjahr”',
  'performanceIndicatorsColumnName.relative_performance_flag_-1': '< -10%',
  'performanceIndicatorsColumnName.relative_performance_flag_0': '-10% to 10%',
  'performanceIndicatorsColumnName.relative_performance_flag_1': '> 10%',
  'performanceIndicatorsColumnName.extreme_walkin_changes_flag': 'Extremer Anstieg der DiWa-Laufkunden',
  'performanceIndicatorsColumnName.extreme_walkin_changes_flag_1': 'Wahrscheinlich früher schlechte DiWa-Nutzung',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag': 'Abschöpfung - Aufträge kleiner 85% der bedienten S&B DiWa Kunden',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag_0': 'Keine oder fragwürdige DiWa-Daten',
  'performanceIndicatorsColumnName.cust_serviced_conversion_rate_flag_1': 'Schlechte Abschöpfung DiWa SB Kunden',
  'performanceIndicatorsColumnName.ratio_of_branch_frontend_bookings': 'WIP: Anteil der Buchungen von "BRANCH_FRONTEND" an allen Buchungen von "Sehtest & Beratung" - WAHRSCHEINLICH UNTERSCHIEDLICH JE NACHDEM OB LTB ODER TIMIFY'
};

export default deDE;
